import styled from 'styled-components';
import { WithDirection } from '@jjj/components';

const HeaderStyles = styled.h2`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 51px 0 8px;
`;

export const Header = WithDirection(HeaderStyles);
